// removed by extract-text-webpack-plugin
module.exports = {"tabsContainer":"tabsContainer-6f21z tabsContainer-cJOxE","tab":"tab-1bWXS tab-2GJzS","tabActive":"tabActive-1TOpr tabActive-3rQTb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/friends/_friendsHeader.css
// module id = 1197
// module chunks = 1